export default __webpack_public_path__ + "static/media/verification-email-received.8d27fce7.svg";